// @ vendors
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const get = require('lodash/object/get');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/actionTypes');
const { error } = require("actions/notifications");
const { getLanguage, formatText } = require('core/i18n').i18n;
const {
    OKDISCOUNT_POST_ERROR,
    OKDISCOUNT_GESTOR_NUMBER,
    DEVICE_TYPE_EMAIL
} = require('constants/index');
const { OKDISCOUNTS_EXTERNAL_CODE_ERRORS } = require('constants/okDiscounts');
// @ utilities
const {
    recordProcess,
    PROC_OK_DISCOUNTS_REGISTER,
    PROC_START,
    PROC_FAIL,
    PROC_END
} = require('utilities/tagging');
const getUserStatusInProgress = () => ({
    type: actionTypes.OKDISCOUNT_REQUEST_FETCH_USER_STATUS
});
const getUserStatusFailure = error => ({
    type: actionTypes.OKDISCOUNT_REQUEST_FETCH_USER_STATUS_FAILURE,
    payload: {
        error
    }
});
const getUserStatusSuccess = data => ({
    type: actionTypes.OKDISCOUNT_REQUEST_FETCH_USER_STATUS_SUCCESS,
    payload: {
        okDiscount: data
    }
});
const subscriptionOKDiscountInProgress = () => ({
    type: actionTypes.OKDISCOUNT_REQUEST_SET_SUBSCRIPTION
});

const subscriptionOKDiscountFailure = error => ({
    type: actionTypes.OKDISCOUNT_REQUEST_SET_SUBSCRIPTION_FAILURE,
    payload: {
        error
    }
});

const subscriptionOKDiscountError = (errorList = []) => ({
    type: actionTypes.OKDISCOUNT_REQUEST_SET_SUBSCRIPTION_ERROR,
    payload: {
        errorList
    }
});

const subscriptionOKDiscountSuccess = (data, email) => ({
    type: actionTypes.OKDISCOUNT_REQUEST_SET_SUBSCRIPTION_SUCCESS,
    payload: {
        okDiscount: data,
        email
    }
});

const register = () => (dispatch, getState) => {
    const profile = getState().profile;
    const deviceList = profile.getIn(['listaDispositivos', 'dispositivo']);
    const email = deviceList
        .filter(device => device.get('tipoDispositivo').trim() === DEVICE_TYPE_EMAIL)
        .getIn(['0', 'detalleContacto'])
        .trim();
    const requestData = {
        query: {
            email: email,
            gestor: OKDISCOUNT_GESTOR_NUMBER
        }
    };

    recordProcess(PROC_OK_DISCOUNTS_REGISTER, PROC_START);
    dispatch(subscriptionOKDiscountInProgress());

    return APIPost({
        dispatch,
        endpoint: 'okDiscountPlans',
        params: requestData
    })
        .then(response => {
            if (response.msg === OKDISCOUNT_POST_ERROR) {
                const detailErrorList = get(response, 'detalleErrorList.detalleErrorList');
                const errorList = detailErrorList.map(errorValue => {
                    return {
                        code: get(errorValue, 'error[0].codigo'),
                        field: get(errorValue, 'campo')
                    }
                });

                recordProcess(PROC_OK_DISCOUNTS_REGISTER, PROC_FAIL);
                return dispatch(subscriptionOKDiscountError(errorList));
            } else {
                recordProcess(PROC_OK_DISCOUNTS_REGISTER, PROC_END);
                return dispatch(subscriptionOKDiscountSuccess(response, email));
            }
        })
        .catch(response => {
            if (!!response.error) {
                recordProcess(PROC_OK_DISCOUNTS_REGISTER, PROC_FAIL);
                dispatch(subscriptionOKDiscountFailure(response));
            } else {
                throw response;
            }
        });
};

const requestOkDiscountDetailInProgress = () => ({
    type: actionTypes.FETCH_OK_DISCOUNT_DETAIL
});

const requestOkDiscountDetailSuccess = (response, categoryId = '') => ({
    type: actionTypes.FETCH_OK_DISCOUNT_DETAIL_SUCCESS,
    payload: {
        categoryId,
        data: response
    }
});

const requestOkDiscountDetailFailure = (error) => ({
    type: actionTypes.FETCH_OK_DISCOUNT_DETAIL_FAILURE,
    payload: {
        error
    }
});

const getUserStatus = () => (dispatch, getState) => {
    const immOkDiscounts = getState().okDiscounts;
    const inProgress = immOkDiscounts.get('inProgress');
    let error = {};

    if (!inProgress) {
        dispatch(getUserStatusInProgress());
        return APIGet(dispatch, apiURLBuilder.getURL('okDiscountPlans'))
            .then(response => {
                if (!!!response.userDiscountStatus) {
                    error.code =
                        response.result.detalleErrorList.detalleErrorList[0].error[0].codigo;
                    error.description =
                        response.result.detalleErrorList.detalleErrorList[0].error[0].descripcion;
                    return dispatch(getUserStatusFailure(error));
                } else {
                    return dispatch(getUserStatusSuccess(response));
                }
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(getUserStatusFailure(response.error));
                } else throw response;
            });
    }
};

const requestDiscountDetail = (discountId, categoryId = '') => (dispatch, getState) => {
    const immOkdiscounts = getState().okDiscounts;
    const isLoading = immOkdiscounts.getIn(['okDiscountDetail', 'isLoading']);
    const language = getLanguage().toUpperCase();

    if (!isLoading) {
        dispatch(requestOkDiscountDetailInProgress());

        const url = apiURLBuilder.getURL('okDiscountDetails', {discountId, language});

        return APIGet(dispatch, url)
            .then(response => dispatch(requestOkDiscountDetailSuccess(response, categoryId)))
            .catch(response => {
                if (!!response.error){
                    dispatch(requestOkDiscountDetailFailure(response.error.description));
                } else {
                    throw response;
                }
            });
    }
};

const requestExternalCodeInProgress = () => ({
    type: actionTypes.OKDISCOUNT_REQUEST_EXTERNAL_CODE_IN_PROGRESS
});

const requestExternalCodeSuccess = (response) => ({
    type: actionTypes.OKDISCOUNT_REQUEST_EXTERNAL_CODE_SUCCESS,
    payload: {
        data: response
    }
});

const requestExternalCodeFailure = (error) => ({
    type: actionTypes.OKDISCOUNT_REQUEST_EXTERNAL_CODE_FAILURE,
    payload: {
        error
    }
});

const requestDiscountDetailsPercentageRequest = () => ({
    type: actionTypes.OKDISCOUNT_REQUEST_DETAILS_PERCENTAGE_REQUEST,
});

const requestDiscountDetailsPercentageSuccess = (data, discountId = '', categoryId = '') => ({
    type: actionTypes.OKDISCOUNT_REQUEST_DETAILS_PERCENTAGE_SUCCESS,
    payload: {
        categoryId,
        data,
        discountId,
    }
});

const requestDiscountDetailsPercentageFailure = (error) => ({
    type: actionTypes.OKDISCOUNT_REQUEST_DETAILS_PERCENTAGE_FAILURE,
    payload: {
        error,
    }
});

const requestExternalCode = () => (dispatch, getState) => {
    const partnerKey = getState().okDiscounts.getIn(['okDiscountDetail', 'discount', 'partnerService']);
    dispatch(requestExternalCodeInProgress());
    return APIGet({
        dispatch,
        endpoint: 'okDiscountExternalCode',
        url: apiURLBuilder.getURL('okDiscountExternalCode', { partnerKey })
    })
        .then((response) => {
            if (response){
                dispatch(requestExternalCodeSuccess(response));
            } else {
                // When the endpoint returns status 204 with null in its response, it means
                // that the promo expired or there are no more codes available, so we show
                // a custom error written by the client in the CMS.
                dispatch(requestExternalCodeFailure(OKDISCOUNTS_EXTERNAL_CODE_ERRORS.CUSTOM));
            }
        })
        .catch((response) => {
            if (!!response.error) {
                dispatch(requestExternalCodeFailure(OKDISCOUNTS_EXTERNAL_CODE_ERRORS.GENERIC));
            } else {
                throw response;
            }
        });
};

const requestDiscountDetailsPercentage = (discountId, categoryId) => dispatch => {
    const requestData = {
        query: {
            defaults: 'exclusive',
            targetAudience: 'default,customers',
        },
    };
    dispatch(requestDiscountDetailsPercentageRequest());
    return APIGet({
        dispatch,
        endpoint: 'okDiscountPercentage',
        params: requestData,
    })
        .then(response => dispatch(requestDiscountDetailsPercentageSuccess(response.data, discountId, categoryId)))
        .catch(response => {
            if (!!response.error) {
                dispatch(requestDiscountDetailsPercentageFailure(response.error));
            } else {
                throw response;
            }
        });
};

const requestReferralPromotionDiscountInProgress = (id) => ({
    type: actionTypes.OKDISCOUNT_REFERRAL_PROMOTION_REQUEST,
    payload: {
        id
    }
});

const requestReferralPromotionDiscountSuccess = () => ({
    type: actionTypes.OKDISCOUNT_REFERRAL_PROMOTION_SUCCESS
});

const requestReferralPromotionDiscountFailure = (id) => ({
    type: actionTypes.OKDISCOUNT_REFERRAL_PROMOTION_FAILURE,
    payload: {
        id
    }
});

const requestReferralPromotionDiscount = (identifier, partnerId, id, callback) => dispatch => {
    const query = { identifier };
    dispatch(requestReferralPromotionDiscountInProgress(id));
    return APIPost(
        dispatch,
        apiURLBuilder.getURL('okDiscountReferralPromotion', { partnerId }),
        {
            query,
            hideDefaultSnackbar: true
        }
    )
        .then(() => {
            dispatch(requestReferralPromotionDiscountSuccess());
            callback();
        })
        .catch(() => {
            dispatch(requestReferralPromotionDiscountFailure(id));
            dispatch(
                error({
                    message: formatText("OKDiscounts-postErrorNotification")
                })
            );
        });
}

module.exports = {
    getUserStatus,
    register,
    requestDiscountDetail,
    requestDiscountDetailsPercentage,
    requestExternalCode,
    requestReferralPromotionDiscount
};
